import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Vertical rhythm.
 *
 * Spacing lives on the container, never as a margin on the child. A child with
 * its own margin behaves differently depending on what it sits next to, which
 * is how a list of cards ends up with three different gaps in it.
 */
export function Stack({ children, gap = 'md', align, justify, grow = false, className, style, as: Component = 'div', }) {
    const classes = [
        'lh-stack',
        `lh-gap-${gap}`,
        align && `lh-align-${align}`,
        justify && `lh-justify-${justify}`,
        grow && 'lh-grow',
        className,
    ]
        .filter(Boolean)
        .join(' ');
    return (_jsx(Component, { className: classes, style: style, children: children }));
}
/**
 * Horizontal grouping, in reading order.
 *
 * `flex-direction: row` follows the document direction, so the first child is
 * the first one read — leading in Arabic, leading in English. Nothing here
 * needs to know which language is active.
 */
export function Inline({ children, gap = 'sm', align = 'center', justify, grow = false, nowrap = false, className, style, as: Component = 'div', }) {
    const classes = [
        'lh-inline',
        `lh-gap-${gap}`,
        `lh-align-${align}`,
        justify && `lh-justify-${justify}`,
        nowrap && 'lh-inline--nowrap',
        grow && 'lh-grow',
        className,
    ]
        .filter(Boolean)
        .join(' ');
    return (_jsx(Component, { className: classes, style: style, children: children }));
}
//# sourceMappingURL=Stack.js.map